import axios from "axios"

export interface AccountOrderSummary {
  id: number
  number: string
  status: string
  total: number
  currency: string
  dateCreated: string
  itemCount: number
}

export interface AccountOrdersResponse {
  ok: boolean
  code?: string
  message?: string
  orders?: AccountOrderSummary[]
}

export const getAccountOrders = async (
  limit = 20
): Promise<AccountOrdersResponse> => {
  const { data } = await axios.get<AccountOrdersResponse>(
    "/api/account/orders",
    {
      params: {
        limit,
      },
    }
  )

  return data
}
